import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import AddressDisplay from 'Components/Account/PaymentInformation/AddressDisplay';
import AddressForm from 'Components/Account/PaymentInformation/AddressForm';

export default function BillingNameAndAddress({ billing }) {
  const [addressOpen, setAddressOpen] = useState(false);
  return (
    <React.Fragment>
      <h2 className="account-table-heading">
        <FormattedMessage id="account-billing.billing-details.title" defaultMessage="Billing Details" />
      </h2>
      <AddressDisplay showDelete userBilling={billing} editAction={() => setAddressOpen(true)} />

      <Modal isOpen={addressOpen} toggle={() => setAddressOpen(!addressOpen)} className="account-modal address-modal">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage id="account-billing.modal.title" defaultMessage="Edit Billing Details" />
          </div>

          <AddressForm
            userBilling={billing}
            billingFields={[
              'customerName',
              'address1',
              'locality',
              'administrativeArea',
              'postalCode',
              'countryCode',
            ]}
            onComplete={() => setAddressOpen(false)}
            onCancel={() => setAddressOpen(false)}
          />
        </ModalBody>

        <div className="close-button-container">
          <button aria-label="close" onClick={() => setAddressOpen(!addressOpen)}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

BillingNameAndAddress.propTypes = {
  billing: PropTypes.shape({}),
};

BillingNameAndAddress.defaultProps = {
  billing: {},
};
